import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react'
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { config } from '../../CommonUtils/CommonURLS';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';

export default function CommanFfcaFacultyAvailability() {
    const hasFetchedData = useRef(false)

    const AfflFacultyRemarksAvailaValidations = Yup.object({
        data: Yup.array().of(Yup.object().shape({
            facultyAvbl: Yup.string().required(ERROR_MSG).nullable(),
            remarks: Yup.string().when('facultyAvbl', {
                is: 'Faculty Deficiency is there',
                then: Yup.string().required(ERROR_MSG).nullable(),
                otherwise: Yup.string().nullable(),
            }),

        })),
    })
    const ffcafacultyavailableFormik = useFormik({
        initialValues: {
            data: [
                {
                    remarks: "",
                    facultyAvbl: "",
                    courseId: "",
                }
            ],
        },
        enableReinitialize: true,
        validationSchema: AfflFacultyRemarksAvailaValidations,
        onSubmit: (values) => {
            values.data.forEach(item => {
                item.courseId = item.courseId ? parseInt(item.courseId, 10) : '';
            });
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveFacultyAvailibityDetails`;
                    CommonAxiosPost(url, values?.data).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetFacultyData();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })


    const [FacultyRemarksData, setFacultyRemarksData] = useState([]);
    function GetFacultyData() {
        let url = config?.url?.API_URL + "FacultyAvailibityDetails";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setFacultyRemarksData(res?.data?.FacultyAvailibityDetails);
            }
            else {
                setFacultyRemarksData([]);
            }

        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetFacultyData();
            hasFetchedData.current = true
        }
    }, [])



    useEffect(() => {

        if (FacultyRemarksData) {
            const dataitialValues = FacultyRemarksData?.map(course => ({
                remarks: course?.remarks,
                facultyAvbl: course?.faculty_avbl,
                courseId: course?.course_cat_id,
            }));
            ffcafacultyavailableFormik.setValues({ ...ffcafacultyavailableFormik?.values, data: dataitialValues });
        }
    }, [FacultyRemarksData]);


    return (
        <>
            <FormikProvider value={ffcafacultyavailableFormik}>
                <Form onChange={ffcafacultyavailableFormik.handleChange} onSubmit={ffcafacultyavailableFormik.handleSubmit}>
                    {FacultyRemarksData?.some(item => item.faculty_avbl == null) ?
                        (<>
                            <div className="table-responsive">

                                <table className="table table-condensed table-bordered  table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Course Name	</th>
                                            <th>Faculty Availability</th>
                                            <th>Remarks</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {FacultyRemarksData && FacultyRemarksData?.map((course, index) => (<>
                                            <tr key={index}>
                                                <td className='cen'>{index + 1}</td>
                                                <td className='text-left'>{course?.course_cat_name}
                                                    {/* <Field type="hidden" name={`data[${index}].courseId`} /> */}
                                                </td>
                                                <td style={{ width: "30%" }} className='text-left'>
                                                    <Field as="select" className="form-control" name={`data[${index}].facultyAvbl`}
                                                        onChange={e => { ffcafacultyavailableFormik?.setFieldValue(`data[${index}].remarks`, ''); }}>
                                                        <option value=''>---select---</option>
                                                        <option value="Faculty Available as per the Norms with required Qualifications and Number">Faculty Available as per the Norms with required Qualifications and Number</option>
                                                        <option value="Faculty Deficiency is there">Faculty Deficiency is there</option>
                                                    </Field>
                                                    <ErrorMessage name={`data[${index}].facultyAvbl`} component="div" className="text-error" />
                                                </td>
                                                {ffcafacultyavailableFormik?.values?.data[index]?.facultyAvbl === "Faculty Deficiency is there" ? (<>
                                                    <td>
                                                        <Field as="textarea" className="form-control" name={`data[${index}].remarks`} maxLength="350" />
                                                        <ErrorMessage name={`data[${index}].remarks`} component="div" className="text-error" />
                                                    </td>
                                                </>) : (<td></td>)}


                                            </tr>

                                        </>))}

                                    </tbody >

                                </table>
                            </div>

                            <div className="button-cend pt-1 mb-5">

                                <button type="submit" className="badge text-bg-success rounded mt-2 float-end" style={{ padding: "10px 20px", fontSize: "15px" }}>
                                    Submit
                                </button>
                            </div>

                        </>) : (<>
                            <div className="table-responsive">

                                <table className="table table-condensed table-bordered  table-responsive affl-table">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Course Name		</th>
                                            <th>Faculty Availability	</th>
                                            <th>Remarks</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {FacultyRemarksData !== undefined && FacultyRemarksData !== null && FacultyRemarksData !== '' && FacultyRemarksData?.map((data, i) => (
                                            <tr key={i}>
                                                <td>{i + 1}</td>
                                                <td className='text-left'>{data?.course_cat_name}</td>
                                                <td className='text-left' >{data?.faculty_avbl}</td>
                                                <td className='text-left'>{data?.remarks}</td>
                                            </tr>))}
                                    </tbody>
                                </table>

                            </div>


                        </>)}
                    <br />
                </Form>
            </FormikProvider>

        </>
    )
}
